import { CustomTypeEntityType } from "../CustomTypes/CustomTypesBase";
import {
  PropertyTranslator,
  ISoftDeletableFilterParametersTranslator,
  IEntryRecordParametersTranslator,
  IModifiedRecordParametersTranslator,
  IEntryRecordLabels,
  IModificationRecordLabels,
  IUniqueEntityLabels,
  IRelatedEntityLabels,
  ICustomFieldSearchTranslator,
} from "../GenericTranslator";
import {
  IUniqueEntity,
  IEntryRecord,
  IRelatedEntity,
  IModificationRecord,
  IEntityMinimalModel,
  IRelation,
  IRelationModel,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  ICreatedRecordParameters,
  IModifiedRecordParameters,
  IPaginationParameters,
  ISoftDeletableFilterParameters,
  EntityConstants,
  ICustomFieldSearch,
} from "../GenericTypes";
import {
  CustomFieldBase,
  CustomFieldBaseFieldLabels,
  CustomFieldBaseFilters,
  CustomFieldBaseFiltersTranslator,
  CustomFieldBaseSortingOptionsConsts,
} from "./CustomFieldsBase";

export const customFieldConstants: EntityConstants<CustomField, CustomFieldFilters> = {
  resource: "custom_fields",
  frontendIndexRoute: "custom_fields",
  entitySingular: "custom field",
  entityPlural: "custom fields",
  icon: "text-cursor-input",
};

export interface CustomField
  extends CustomFieldBase,
    IUniqueEntity,
    IEntryRecord,
    IModificationRecord,
    IRelatedEntity<CustomFieldRelations> {
  customFieldTemplate: IEntityMinimalModel;
}

export const CustomFieldFieldLabels: PropertyTranslator<CustomField> & {
  isMultiValue: string;
  isTimeRange: string;
  isFloat: string;
  isDateTime: string;
  isDateTimeRange: string;
  entitySelectOption: string;
} = {
  ...CustomFieldBaseFieldLabels,
  ...IUniqueEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...IRelatedEntityLabels,
  customFieldTemplate: "Based on template",
} as const;

export interface CustomFieldSuggestions extends IEntityMinimalModel<CustomField["id"]> {}

export interface CustomFieldRelations extends IRelationModel {
  types: IRelation;
  datasets: IRelation;
  samples: IRelation;
  inventoryItems: IRelation;
  projects: IRelation;
  persons: IRelation;
}
export interface CustomFieldFilters
  extends CustomFieldBaseFilters<CustomFieldSortingOptions>,
    ICustomFieldSearch,
    ICreatedRecordParameters,
    IModifiedRecordParameters,
    ISoftDeletableFilterParameters {
  customTypeEntityTypes?: CustomTypeEntityType[] | null;
}

export const CustomFieldSortingOptionsConsts = [
  ...CustomFieldBaseSortingOptionsConsts,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
] as const;
export type CustomFieldSortingOptions = (typeof CustomFieldSortingOptionsConsts)[number];

export const CustomFieldFiltersTranslator: PropertyTranslator<CustomFieldFilters> = {
  ...ICustomFieldSearchTranslator,
  ...CustomFieldBaseFiltersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  ...ISoftDeletableFilterParametersTranslator,
  customTypeEntityTypes: "Custom type entity types",
} as const;

export interface CustomFieldValuesFilters extends IPaginationParameters {
  searchTerm?: string | null;
  includeCount?: boolean;
}
